// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const amphoraRack = defineModel({
  id: "amphora-rack",
  batchId: "future",
  name: "Amphora rack",
  tags: ["scenery","amphora","rack","low-poly","age-of-mcp","future"],
  summary: "A rack of sealed jars — oil and wine stored and shipped.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.44,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.045, 0.4, 0.045), color: "#7a5a36", position: [-0.1, 0.17, -0.26], rotation: [0, 0, -0.53] },
      { geometry: new THREE.BoxGeometry(0.045, 0.4, 0.045), color: "#7a5a36", position: [0.1, 0.17, -0.26], rotation: [0, 0, 0.53] },
      { geometry: new THREE.BoxGeometry(0.045, 0.4, 0.045), color: "#7a5a36", position: [-0.1, 0.17, 0.26], rotation: [0, 0, -0.53] },
      { geometry: new THREE.BoxGeometry(0.045, 0.4, 0.045), color: "#7a5a36", position: [0.1, 0.17, 0.26], rotation: [0, 0, 0.53] },
      { geometry: new THREE.BoxGeometry(0.05, 0.05, 0.62), color: "#6b4e2e", position: [0, 0.345, 0] },
      { geometry: new THREE.BoxGeometry(0.045, 0.045, 0.62), color: "#6b4e2e", position: [-0.18, 0.04, 0] },
      { geometry: new THREE.BoxGeometry(0.045, 0.045, 0.62), color: "#6b4e2e", position: [0.18, 0.04, 0] },
      { geometry: new THREE.CylinderGeometry(0.04125, 0.03, 0.096, 8), color: "#b06a40", position: [0, 0.048, -0.21] },
      { geometry: new THREE.SphereGeometry(0.075, 8, 6), color: "#b06a40", position: [0, 0.15, -0.21], scale: [1, 1.05, 1] },
      { geometry: new THREE.CylinderGeometry(0.021, 0.0255, 0.066, 8), color: "#b06a40", position: [0, 0.258, -0.21] },
      { geometry: new THREE.CylinderGeometry(0.04125, 0.03, 0.096, 8), color: "#a35e38", position: [0, 0.048, -0.07] },
      { geometry: new THREE.SphereGeometry(0.075, 8, 6), color: "#a35e38", position: [0, 0.15, -0.07], scale: [1, 1.05, 1] },
      { geometry: new THREE.CylinderGeometry(0.021, 0.0255, 0.066, 8), color: "#a35e38", position: [0, 0.258, -0.07] },
      { geometry: new THREE.CylinderGeometry(0.04125, 0.03, 0.096, 8), color: "#b06a40", position: [0, 0.048, 0.07] },
      { geometry: new THREE.SphereGeometry(0.075, 8, 6), color: "#b06a40", position: [0, 0.15, 0.07], scale: [1, 1.05, 1] },
      { geometry: new THREE.CylinderGeometry(0.021, 0.0255, 0.066, 8), color: "#b06a40", position: [0, 0.258, 0.07] },
      { geometry: new THREE.CylinderGeometry(0.04125, 0.03, 0.096, 8), color: "#a35e38", position: [0, 0.048, 0.21] },
      { geometry: new THREE.SphereGeometry(0.075, 8, 6), color: "#a35e38", position: [0, 0.15, 0.21], scale: [1, 1.05, 1] },
      { geometry: new THREE.CylinderGeometry(0.021, 0.0255, 0.066, 8), color: "#a35e38", position: [0, 0.258, 0.21] },
    ],
  animations: [],
});
